import stockAPI from "@/utility/api.js";

const state = {
  applyingUsers: [],
  passUsers: [],
  blackList: [],
  userDetail: {},
  accountsLog: []
};

const getters = {
  applyingUsers(state) {
    return state.applyingUsers;
  },
  passUsers(state) {
    return state.passUsers;
  },
  blackList(state) {
    return state.blackList;
  },
  userDetail(state) {
    const initData = {
      created_at: "2020.01.01 13:00",
      account: "xx",
      name: "xxxx",
      email: "xxx",
      phone: "123",
      seniority: 1,
      introduction: "hi"
    };
    if (!state.userDetail.account) {
      return initData;
    } else {
      return state.userDetail;
    }
  },
  accountsLog(state) {
    return state.accountsLog;
  }
};

const mutations = {
  applyingUsers(state, res) {
    state.applyingUsers = res;
  },
  passUsers(state, res) {
    state.passUsers = res;
  },
  blackList(state, res) {
    state.blackList = res;
  },
  userDetail(state, res) {
    state.userDetail = Object.assign({}, res);
  },
  accountsLog(state, res) {
    state.accountsLog = res;
  }
};
const actions = {
  async fetchApplyingUsers({ commit }) {
    const res = await stockAPI.GET(`api/registered/users`);
    if (res) {
      commit("applyingUsers", res);
      return Promise.resolve();
    }
  },
  async fetchPassUsers({ commit }) {
    const res = await stockAPI.GET(`api/verified/users`);
    if (res) {
      commit("passUsers", res);
      return Promise.resolve();
    }
  },
  async fetchBlackList({ commit }) {
    const res = await stockAPI.GET(`api/blacklist/users`);
    if (res) {
      commit("blackList", res);
      return Promise.resolve();
    }
  },
  // eslint-disable-next-line no-unused-vars
  postBlackUser({ state }, user) {
    user.result = true; //true 表示加入黑名單
    const data = {
      users: [user]
    };
    return stockAPI.POST(`api/blacklist`, data);
  },
  // eslint-disable-next-line no-unused-vars
  deleteBlackUser({ state }, user) {
    const data = {
      users: [user]
    };
    return stockAPI.DELETE(`api/blacklist`, data);
  },
  // eslint-disable-next-line no-unused-vars
  postVerifyEmail({ state }, selectedList) {
    const data = {
      users: selectedList
    };
    return stockAPI.POST(`api/email/verify`, data);
  },
  async fetchAccountsLog({ commit }) {
    const res = await stockAPI.GET(`api/recently-login/users`);
    if (res) {
      commit("accountsLog", res);
      return Promise.resolve();
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
